export const SET_FETCHING_FLAG = "SET_FETCHING_FLAG";
export const GET_SERVICES_LIST = "GET_SERVICES_LIST";
export const SET_SELECTED_SERVICE = "SET_SELECTED_SERVICE";
export const GET_REQUESTS_LIST = "GET_REQUESTS_LIST";
export const SET_SELECTED_REQUEST = "SET_SELECTED_REQUEST";
export const CREATE_REQUEST = "CREATE_REQUEST";
export const UPDATE_REQUEST = "UPDATE_REQUEST";
export const GET_SERVERS_LIST = "GET_SERVERS_LIST";
export const SET_TOAST = "SET_TOAST";